import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import routerHelper from '$$routerHelper';
import workloadLayout from '../../../views/ganttView/workload/layout';
import workloadCore from '../../../views/ganttView/workload/core';
import workloadToXlsx from '../../../views/ganttView/workload/export';
import app from '$$app';

export default instance => {
  instance.attachEvent('onWorkloadUpdateTask', task => {
    globalStore.dispatch('tasksModel/updateTasks', { 
      tasks: [task], 
      sourceEvent: { type: constants.GANTT_SOURCE_EVENT_TYPES.TASK_UPDATE, sourceId: task.id }, 
      fromGantt: false 
    });
  });
  instance.attachEvent('onClickWorkloadExpandButton', async () => {
    let workloadActivity = globalStore.getters['user/getActivitySettings'](constants.USER_ACTIVITIES.WORKLOAD);
    const id = instance.config.gantt_id || instance.config.multiview_id;
    let resultFlag = false; // base default state
    let workloadHeight = constants.WORKLOAD_PANEL_DEFAULT_HEIGHT;

    if (!workloadActivity) {
      workloadActivity = {};
    }

    if (!workloadActivity.panelOpenState) {
      workloadActivity.panelOpenState = {
        [id]: true,
      };

      resultFlag = true;
    } else {
      resultFlag = !workloadActivity.panelOpenState[id];
      workloadActivity.panelOpenState[id] = resultFlag;
    }

    await globalStore.dispatch('user/updateActivitySettings', {
      activityName: constants.USER_ACTIVITIES.WORKLOAD,
      settings: workloadActivity,
    });

    if (workloadActivity.workloadHeight) {
      workloadHeight = workloadActivity.workloadHeight[id];
    }

    workloadLayout.togglePanelAndRender(resultFlag, workloadHeight);

    resultFlag && userExtAnalytics.log('workload_open', { from: 'gantt view' });
  });
  instance.attachEvent('onChangeWorkloadHeight', newHeight => {
    let workloadActivity = globalStore.getters['user/getActivitySettings'](constants.USER_ACTIVITIES.WORKLOAD);
    const id = instance.config.gantt_id || instance.config.multiview_id;
    let isNeedSave = false;

    if (!workloadActivity) {
      workloadActivity = {};
    }

    if (!workloadActivity.workloadHeight) {
      workloadActivity.workloadHeight = {
        [id]: newHeight,
      };
      isNeedSave = true;
    } else {
      const oldHeight = workloadActivity.workloadHeight[id];

      if (oldHeight !== newHeight) {
        workloadActivity.workloadHeight[id] = newHeight;
        isNeedSave = true;
      }
    }

    isNeedSave && globalStore.dispatch('user/updateActivitySettings', {
      activityName: constants.USER_ACTIVITIES.WORKLOAD,
      settings: workloadActivity,
    });
  });

  instance.attachEvent('onChangeWorkloadViewMode', mode => {
    let workloadActivity = globalStore.getters['user/getActivitySettings'](constants.USER_ACTIVITIES.WORKLOAD);
    const projectId = +routerHelper.getCurrentRoute().params.projectId;
    const multiviewId = +routerHelper.getCurrentRoute().params.multiviewID;
    const contextId = projectId || multiviewId || 'global';

    if (!workloadActivity) {
      workloadActivity = {};
    }

    if (!workloadActivity.viewMode) {
      workloadActivity.viewMode = {};
    }

    if (workloadActivity.viewMode[contextId] === mode) {
      return;
    }

    workloadActivity.viewMode[contextId] = mode;

    globalStore.dispatch('user/updateActivitySettings', {
      activityName: constants.USER_ACTIVITIES.WORKLOAD,
      settings: workloadActivity,
    });
  });

  instance.attachEvent('onChangeWorkloadZoom', zoom => {
    let workloadActivity = globalStore.getters['user/getActivitySettings'](constants.USER_ACTIVITIES.WORKLOAD);

    if (!workloadActivity) {
      workloadActivity = {};
    }

    if (workloadActivity.zoom === zoom) {
      return;
    }

    workloadActivity.zoom = zoom;

    globalStore.dispatch('user/updateActivitySettings', {
      activityName: constants.USER_ACTIVITIES.WORKLOAD,
      settings: workloadActivity,
    });

    workloadCore.changeZoom(zoom);
  });

  instance.attachEvent('onClickResourceCalendarIcon', resourceId => {
    app.trigger('showPersonalCalendar', resourceId);
  });

  instance.attachEvent('onClickWorkloadResourceRow', (rowId, scrollXratio = 1) => {
    const previousModes = {
      year: 4,
      quarter: 3,
      month: 2,
      week: 1,
    };
    const zoom = instance.config.durationData.mode;

    if (zoom !== 'day' && previousModes[zoom]) {
      if (workloadCore.config.type === constants.WORKLOAD_TYPES.panel) {
        globalStore.commit('headerView/setZoom', [previousModes[zoom]]);
      } else {
        globalStore.commit('headerView/setWorkloadZoom', [previousModes[zoom]]);
      }

      instance.$ui.getView('scrollHor').scrollTo(
        (instance.getScrollState().width - instance.$ui.getView('workloadTimeline').$task.offsetWidth) * scrollXratio,
        null,
      );
    } else {
      workloadCore.config.openedResources[rowId] = !workloadCore.config.openedResources[rowId];
      instance.callEvent('workloadRecalculate');

      if (workloadCore.config.openedResources[rowId]) {
        const from = 'general';

        // TODO
        // if (routerHelper.isGanttGridRoute()) from = 'gantt view';

        // if (routerHelper.isMultiProjectsRoute() || routerHelper.isSingleProjectRoute()) {
        //   if (routerHelper.isWorkloadViewRoute()) { from = 'workload tab'; }
        // }

        userExtAnalytics.log('workload_resource_open', { from });
      }
    }
  });

  const appSubscriptions = [];

  appSubscriptions.push(app.on('onChangeWorkloadRange', range => {
    // if (!pricingHelper.checkPricingAccess('workload')) {
    //   app.trigger('gantt:progress:hide', true);
    // }

    // _.delay(() => {
    //   _state.scrollX = 0;
    //   workloadCore.updateState({ filter: { projects: [], resources: [] }, visibleUnassignedTasksRows: PARTIAL_ROWS_COUNT });
    //   _initWorkload({ dateRange: range, closeResources: true });
    // });

    workloadLayout.changeRange(range);

    let workloadActivity = globalStore.getters['user/getActivitySettings'](constants.USER_ACTIVITIES.WORKLOAD);

    if (!workloadActivity) {
      workloadActivity = {};
    }

    workloadActivity = { ...workloadActivity, ...range };

    globalStore.dispatch('user/updateActivitySettings', {
      activityName: constants.USER_ACTIVITIES.WORKLOAD,
      settings: workloadActivity,
    });
  }));

  appSubscriptions.push(app.on('header:export:workload', () => {
    workloadToXlsx({
      title: __('workload_title'),
      data: {
        workload: _.cloneDeep(instance.getDatastore('workloadStore').pull),
        order: _.cloneDeep(instance.getDatastore('workloadStore').fullOrder),
        scale: _.cloneDeep(instance.$ui.getView('workloadTimeline').getScale()),
        viewMode: workloadCore.config.viewMode,
      },
    });
  }));

  // TODO remove to store listeners after migrate projects model to vuex
  appSubscriptions.push(app.on('project:archive', () => {
    instance.callEvent('workloadClearAndParse');
  }));

  return {
    appSubscriptions,
  };
};
